import React, { Component } from "react";
import { Grid, Avatar, Typography, Icon } from '@material-ui/core';
import { connect } from "react-redux";

import { webFont, textBlack, textGrey, primaryColor } from '../../config/theme';
import { getSavedChefs } from "../../redux/user";

const defaultChefImg = "/images/simple-chef.webp";
const tick = "/images/tick.webp";

class FChefs extends Component {
  state = {
    featuredChefsList: []
  };

  componentDidMount() {
   const {dispatch, userId} = this.props;
   dispatch(getSavedChefs(userId));
  }

  showChefProfile = chefId => {
    let liked=true;
    this.props.history.push("/home/chef-profile", { chefId,liked, screen: 'saved' });
  };

  render() {
    const { savedChefs: featuredChefsList } = this.props;

    let fChefs = null;
    if (featuredChefsList.length > 0) {
      fChefs = featuredChefsList.map(chef => {
        let chefRatings = 0;
        let ratingStars = null;

        if (chef.rating) {
          if (chef.rating > 0) {
            chefRatings = Math.floor(chef.rating);
          }
        }

        if (chefRatings > 0) {
          switch (chefRatings) {
            case 1:
              ratingStars = <Icon style={style.ratingIcon}>star_rate</Icon>;
              break;

            case 2:
              ratingStars = (
                <div>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                </div>
              );
              break;

            case 3:
              ratingStars = (
                <div>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                </div>
              );
              break;

            case 4:
              ratingStars = (
                <div>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                </div>
              );
              break;

            case 5:
              ratingStars = (
                <div>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                  <Icon style={style.ratingIcon}>star_rate</Icon>
                </div>
              );
              break;
          }
        } else {
          chefRatings = "";
        }

        return (
          <Grid
            key={chef.id}
            className="featured-item-save"
            onClick={() => this.showChefProfile(chef.id)}
          >
            <Grid container alignItems="center" style={{ position: 'relative' }}>
              <Avatar
                data-test-id={"savedchefpic"}
                src={chef.profilePic ? chef.profilePic : defaultChefImg}
                alt="Image not available"
                style={style.avatarImg}
              />
              {chef.verified && <div style={{ position: 'absolute', top: 0, right: 10 }}>
                <img src={tick} alt="Verified Chef" style={style.tick} />
              </div>}
              <Grid data-test-id={"savedchefname"} item xs={12}>
                <Typography
                  align="center"
                  variant="h6"
                  style={style.chefName}
                  gutterBottom={true}
                >
                  {chef.firstName} {chef.lastName}
                </Typography>
              </Grid>
              <Grid data-test-id={"savedcuis"}  item xs={12}>
                <Typography
                  align="center"
                  variant="body1"
                  style={style.chefCuisine}
                  gutterBottom={true}
                  noWrap={true}
                >
                  {chef.cuisines && chef.cuisines.length>3 ? "Multi Cuisines" :chef.cuisines.toString().replace(/,/g, ', ')}
                </Typography>
              </Grid>
              <Grid data-test-id={"savedrtngs"}  item xs={12} alignItems={"center"} alignContent={"center"} justify={"center"} style={{textAlign: 'center'}}>
                <Typography
                  align="center"
                  variant="body1"
                  style={style.chefCuisine}
                  gutterBottom={true}
                  noWrap={true}
                >
                  {chefRatings === '' ? chefRatings : ratingStars}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        );
      });
    }

    return (
      <Grid container direction="row" style={style.ftGrid}>
        <Grid container alignItems="flex-start">
          <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 20 }} />
          <Grid item xs={6} md={4} lg={4} xl={2} >
            <Typography variant="h5" style={{...style.ftText, textAlign: 'center' }} align={"center"}>
              Saved chefs
            </Typography>
          </Grid>
          <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 20 }}  />
        </Grid>
        <Grid container alignItems={"center"} justify={"center"}>
          {fChefs}
        </Grid>

        {featuredChefsList.length === 0 && <Grid container alignItems={"center"} justify={"center"}>
          <Typography variant="h5" style={style.ftText}>
            No saved chefs
          </Typography>
        </Grid>}
      </Grid>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    savedChefs: state.user.savedChefs,
  };
};

const FeaturedChefs = connect(mapStateToProps)(FChefs);

export default FeaturedChefs;

const style = {
  tick: {
    width: 28,
    height: 28,
  },
  avatarImg: {
    width: 203,
    height: 203,
    margin: '0 auto',
  },
  ftGrid: {
    marginTop: 40,
    marginBottom: 10
  },
  ftText: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
    fontSize: 30,
    marginBottom: 40,
  },
  chefName: {
    fontFamily: webFont,
    color: '#444444',
    fontWeight: 500,
    fontSize: 20,
    margin: '20px 0 1px',
  },
  chefCuisine: {
    fontFamily: webFont,
    color: '#979797',
    opacity: '0.8',
    margin: 0,
    fontSize: 15,
  },
  ratings: {
    color: primaryColor,
    weight: 500,
    maxWidth: '100%'
  },
  ratingIcon: {
    color: primaryColor,
    fontSize: 16,
  },
  showBtn: {
    width: "220px",
    borderRadius: 40,
    paddingLeft: 20,
    paddingRight: 20,
    textTransform: "none",
    marginTop: 30,
    fontFamily: webFont
  }
};
